module.exports = __webpack_public_path__ + "6652095b3d6afa0f7dc492592f3ae3f5.svg";